<template>
  <div class="conversion-wrapper">
    <app-filter :filter-list="table_filter" @search="search" />
    <app-table
      ref="conversion_table_ref"
      :table-key="table_key"
      :tablep="tableParams"
      :get-data="getList"
    />
  </div>
</template>

<script>
import { data_sharing_mixin } from '@/views/fusion/investment/intelligence-create/mixins/data-sharing';

export default {
  components: {
    'app-filter': () => import('@/components/app-filter'),
    'app-table': () => import('@/components/app-table'),
  },
  mixins: [data_sharing_mixin],
  props: {
    /** 广告主账户ID */
    advertiserId: {
      type: [Number, String],
      default: null,
    },
    /** 已选表格数据 */
    tableSources: {
      type: Object,
      default: () => {
        return {
          list: [{}],
          page_info: {
            total_number: 0,
            page: 1,
            page_size: 10,
            total_page: 0,
          },
        };
      },

    },
    /** 表格查询参数 */
    tableParams: {
      type: Object,
      required: true,
    },
    /** 表格请求方法 */
    getList: {
      type: Function,
      required: true,
    },
  },
  data() {
    return {
      table_filter: require('./model/table-filter.js')(this),
      table_key: require('./model/table-key.js')(this),
    };
  },
  methods: {
    /**
     * 搜索
     * @param {Object} params 过滤参数
     */
    search(params) {
      Object.assign(this.tableParams.filtering, { ...params.filtering });
      this.$refs.conversion_table_ref.seekTable();
    },

    /**
     * 确定选择转化
     * @param {Object} data 转化数据
     */
    onDataDialogConfirm(data) {
      this.$emit('confirm', data, this.advertiserId);
    },
  },
};
</script>
